module.exports = __webpack_public_path__ + "static/media/minus-red.72f9f19d.svg";